import type { AccountNumberDto } from '@dhl/mdp-api'
import { inverseSelectedKeys, type Account } from '~/common/components/accountnumbers'
import { type ParcelTypeDto, type Product } from '~/common/model/capabilities'

export const toAccount = (
  allProducts: Product[],
  allParcelTypes: ParcelTypeDto[],
  {
    id,
    accountType,
    organisationId,
    countryCode,
    parcelTypeBlacklist = [],
    optionWhitelist,
    returnHubLinks,
    blockedInfo,
    selfOnboardingInfo,
    activeProducts = [],
  }: AccountNumberDto
): Account => {
  const selectedProducts: Product[] = allProducts
    .filter((product) => activeProducts.includes(product.value))
    .sort()
    .map((selectedProduct) => {
      const returnHubLink = returnHubLinks?.find((link) => link.returnProductCode === selectedProduct.value)
      return {
        ...selectedProduct,
        locationId: returnHubLink?.locationId,
        returnHubId: returnHubLink?.returnHubId,
        additionalCustomerInformation: returnHubLink?.additionalCustomerInformation,
      }
    })
  return {
    id,
    accountType,
    organisationId,
    countryCode,
    selectedProducts,
    selectedParcelTypes: inverseSelectedKeys(parcelTypeBlacklist, allParcelTypes).sort(),
    selectedShipmentOptions: optionWhitelist,
    /*
     * `blockedInfo` is an optional field that shows if an account is on credit stop and (optionally) since when
     *  this occurred. We need to pick some sane defaults in case it's not present.
     */
    blockedInfo: blockedInfo || { isBlocked: false },
    selfOnboardingInfo: selfOnboardingInfo,
  } as Account
}
